import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import IssueDetails from "../../components/IssueDetails/IssueDetails";
import IssueComments from "../../components/IssueComments/IssueComments";
import RecommendedIssues from "../../components/IssueDetails/RecommendedIssues";
import AddIssueDrawer from "../../components/Crop/AddIssueDrawer";
import getIssueDetails from "../../components/IssueDetails/getIssueDetails";
import LoadingSpinner from "../../components/reusable/LoadingSpinner";
import { useParams, useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faPlus,
  faChevronDown,
  faChevronUp,
  faUser,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";

const C = {
  dark: "#1a3328",
  mid: "#2d5a3d",
  bright: "#3d8c5e",
  light: "#e8f5ee",
  page: "#edf5ef",
  border: "#d8e8dc",
  cardBorder: "#c6deca",
  white: "#ffffff",
  textDk: "#1a2e22",
  textGr: "#5a6e61",
  orange: "#e65100",
  orangeBg: "#fff3e0",
  blue: "#1565c0",
  blueBg: "#e3f2fd",
  red: "#c62828",
  redBg: "#fdecea",
};

const issueStatusStyle = (status) => {
  const map = {
    New: { bg: C.blueBg, color: C.blue },
    "In Progress": { bg: C.orangeBg, color: C.orange },
    SolutionProvided: { bg: "#e8f5e9", color: "#2e7d32" },
    Done: { bg: C.light, color: C.mid },
    "On Hold": { bg: "#eceff1", color: "#607d8b" },
    "In Follow": { bg: "#f3e5f5", color: "#7b1fa2" },
    Rejected: { bg: C.redBg, color: C.red },
  };
  return map[status] || { bg: "#f5f5f5", color: "#555" };
};

const ViewIssue = () => {
  const { issueCode } = useParams();
  const history = useHistory();
  const [issueDetails, setIssueDetails] = useState(null);
  const [reloadDetails, setReloadDetails] = useState(false);
  const [fetching, setFetching] = useState(true);
  const [showSimilar, setShowSimilar] = useState(false);
  const [similarCount, setSimilarCount] = useState(null);
  const [showAddIssue, setShowAddIssue] = useState(false);

  const reloadData = () => {
    setReloadDetails(!reloadDetails);
  };

  const loadIssueDetails = async () => {
    setFetching(true);
    const issueDetailsResponse = await getIssueDetails(issueCode);
    if (issueDetailsResponse.status == 200) {
      console.log("Issuesloaded");
      console.log(issueDetailsResponse);
      setIssueDetails(issueDetailsResponse.data.issue);
    } else {
      console.log(issueDetailsResponse);
    }
    setFetching(false);
  };

  useEffect(() => {
    loadIssueDetails();
  }, [reloadDetails]);


  if (fetching) {
    return (
      <div style={{ marginTop: "5rem" }}>
        <LoadingSpinner />
      </div>
    );
  }

  const farmer = issueDetails?.farmerID;
  const st = issueDetails?.status ? issueStatusStyle(issueDetails.status) : {};

  return (
    <div style={{ backgroundColor: C.page, minHeight: "100vh" }}>
      {/* ── Light page header ─────────────────────────────────────────────── */}
      <div
        style={{
          backgroundColor: C.white,
          borderBottom: `2px solid ${C.cardBorder}`,
          padding: "0.7rem 1.5rem",
          display: "flex",
          alignItems: "center",
          gap: "0.85rem",
          flexWrap: "wrap",
          boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
        }}
      >
        {/* Back */}
        <button
          onClick={() => history.push('/crop')}
          style={{
            background: C.light,
            border: `1px solid ${C.border}`,
            borderRadius: 7,
            color: C.dark,
            width: 34,
            height: 34,
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <FontAwesomeIcon
            icon={faChevronLeft}
            style={{ fontSize: "0.8rem" }}
          />
        </button>

        {/* Issue code + status + title */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            flex: 1,
            minWidth: 0,
          }}
        >
          <span
            style={{
              fontWeight: 800,
              fontSize: "0.95rem",
              color: C.textDk,
              whiteSpace: "nowrap",
            }}
          >
            {issueDetails?.issueCode || "Issue"}
          </span>
          {issueDetails?.status && (
            <span
              style={{
                fontSize: "0.68rem",
                fontWeight: 700,
                padding: "3px 10px",
                borderRadius: 9,
                backgroundColor: st.bg,
                color: st.color,
                whiteSpace: "nowrap",
              }}
            >
              {issueDetails.status}
            </span>
          )}
          {issueDetails?.title && (
            <span
              style={{
                fontSize: "0.82rem",
                color: C.textGr,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              · {issueDetails.title}
            </span>
          )}
        </div>

        {/* Farmer pill */}
        {farmer && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "0.5rem",
              backgroundColor: C.light,
              border: `1px solid ${C.border}`,
              borderRadius: 9,
              padding: "0.3rem 0.75rem",
              flexShrink: 0,
            }}
          >
            <div
              style={{
                width: 28,
                height: 28,
                borderRadius: "50%",
                backgroundColor: C.mid,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              <FontAwesomeIcon
                icon={faUser}
                style={{ color: "#fff", fontSize: "0.65rem" }}
              />
            </div>
            <div>
              <div
                style={{
                  fontSize: "0.65rem",
                  color: C.textGr,
                  textTransform: "uppercase",
                  letterSpacing: "0.05em",
                  lineHeight: 1,
                }}
              >
                Farmer
              </div>
              <div
                style={{
                  fontSize: "0.82rem",
                  fontWeight: 700,
                  color: C.textDk,
                  lineHeight: 1.2,
                }}
              >
                {farmer.fullName || "—"}
              </div>
              {farmer.mobileNumber && (
                <div style={{ fontSize: "0.65rem", color: C.textGr }}>
                  <FontAwesomeIcon
                    icon={faPhone}
                    style={{ fontSize: "0.55rem", marginRight: 2 }}
                  />
                  {farmer.mobileNumber}
                </div>
              )}
            </div>
          </div>
        )}

        {/* New Issue */}
        {farmer && (
          <button
            onClick={() => setShowAddIssue(true)}
            style={{
              backgroundColor: C.mid,
              color: "#fff",
              border: "none",
              borderRadius: 7,
              padding: "0.45rem 1.2rem",
              fontSize: "0.85rem",
              fontWeight: 700,
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: 6,
              boxShadow: "0 2px 8px rgba(45,90,61,0.3)",
              flexShrink: 0,
            }}
          >
            <FontAwesomeIcon icon={faPlus} style={{ fontSize: "0.75rem" }} />
            New Query
          </button>
        )}
      </div>

      {/* ── Body ─────────────────────────────────────────────────────────── */}
      <Container fluid style={{ padding: "1.25rem 1rem 2rem" }}>
        <div style={{ display: "flex", gap: "1rem", alignItems: "flex-start" }}>

          {/* Left: Issue Details */}
          <div style={{ flex: "0 0 57%", minWidth: 0 }}>
            {issueDetails && (
              <IssueDetails issueDetails={issueDetails} reloadData={reloadData} />
            )}
          </div>

          {/* Right: Comments */}
          <div style={{ flex: 1, minWidth: 0, display: "flex", flexDirection: "column", gap: "1rem" }}>
            {issueDetails && (
              <IssueComments issueDetails={issueDetails} reloadData={reloadData} />
            )}
          </div>
        </div>

        {/* Similar Issues — dark-green card, collapsed by default */}
        <div
          style={{
            marginTop: "1rem",
            borderRadius: 10,
            border: `1.5px solid ${C.cardBorder}`,
            overflow: "hidden",
            boxShadow: "0 2px 10px rgba(20,50,30,0.06)",
          }}
        >
          {/* Header — same style as other section cards */}
          <button
            onClick={() => setShowSimilar((s) => !s)}
            style={{
              width: "100%",
              backgroundColor: C.dark,
              border: "none",
              borderBottom: showSimilar ? `1.5px solid ${C.cardBorder}` : "none",
              borderRadius: showSimilar ? "10px 10px 0 0" : 10,
              padding: "0.85rem 1.25rem",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              cursor: "pointer",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
              <span style={{ fontWeight: 700, fontSize: "0.85rem", letterSpacing: "0.06em", textTransform: "uppercase", color: "#fff" }}>
                Similar Queries
              </span>
              {similarCount !== null && (
                <span style={{ fontSize: "0.72rem", fontWeight: 700, padding: "2px 9px", borderRadius: 8, backgroundColor: "rgba(255,255,255,0.18)", color: "#fff" }}>
                  {similarCount}
                </span>
              )}
            </div>
            <FontAwesomeIcon icon={showSimilar ? faChevronUp : faChevronDown} style={{ color: "rgba(255,255,255,0.65)", fontSize: "0.7rem" }} />
          </button>

          {!showSimilar && (
            <div style={{ backgroundColor: C.white, padding: "0.65rem 1.25rem", fontSize: "0.8rem", color: C.textGr }}>
              Queries with the same crop or problem type — click to expand.
            </div>
          )}

          {showSimilar && issueDetails && (
            <div style={{ backgroundColor: C.white }}>
              <RecommendedIssues
                issueDetails={issueDetails}
                reloadData={reloadData}
                onCountLoaded={setSimilarCount}
              />
            </div>
          )}
        </div>
      </Container>

      {/* ── Add Issue Drawer ──────────────────────────────────────────────── */}
      {showAddIssue && (
        <AddIssueDrawer
          farmer={farmer}
          onClose={() => setShowAddIssue(false)}
          onSuccess={() => { setShowAddIssue(false); reloadData(); }}
        />
      )}
    </div>
  );
};

export default ViewIssue;
